import React from "react"
import {Route} from "react-router-dom"
import Painel from "./Painel"
import Plan from "./Plan"
import Edit from "./Plan/edit"
import Report from "./Report"
import ReportCreate from "./Report/create"
import ReportSave from "./Report/edit"
import ReportPreview from "./Report/preview"
import DemoFinancial from "./Financial"
import PreviewFinancial from "./Financial/preview"
import Cockpit from "./Cockpit"
import CockpitPreview from "./Cockpit/preview"

/*
    @TODO MOCK SCHNEIDER
 */
import ReportCreateSCH from "./ReportSchneider/create"
import ReportPreviewSCH from "./ReportSchneider/preview"
import ReportPreviewEditSCH from "./ReportSchneider/previewEDT"


/*
 @TODO MOCK EXPLORER
 */
import Explorer from "./Explorer"


/*
 @TODO RH ESTEE
 */
import RhEstee from "./RhStee/create"
import RhEsteeEdit from "./RhStee/previewEDT"


/*
 @TODO USER
 */
import UserAdd from "./UserConfig"
import UserPermission from "./UserConfig/permission"


// export default () => (
//   <>
//     <Route
//       path="/pedidos/status"
//       exact
//       component={(props) => <Status {...props} />}
//     />
//     <Route
//       path="/pedidos/volume"
//       exact
//       component={(props) => <Volume {...props} />}
//     />
//     <Route
//       path="/pedidos/cliente"
//       exact
//       component={(props) => <Cliente {...props} />}
//     />
//     <Route
//       path="/pedidos/sku"
//       exact
//       component={(props) => <SKU {...props} />}
//     />
//   </>
// )

export default [

    {
        path: "/user/config",
        component: UserAdd,
    },
    {
        path: "/user/permission",
        component: UserPermission,
    },


    {
        path: "/ij/painel/:id",
        component: Painel,
    },
    {
        path: "/ij/plan",
        component: Plan,
    },
    {
        path: "/ij/plan_edit",
        component: Edit,
    },
    {
        path: "/ij/report",
        component: Report,
    },
    {
        path: "/ij/explorer",
        component: Explorer,
    },
    {
        path: "/ij/report_create",
        component: ReportCreate,
    },
    {
        path: "/ij/report_create_schneider",
        component: ReportCreateSCH,
    },
    {
        path: "/ij/report_preview_schneider",
        component: ReportPreviewSCH,
    },
    {
        path: "/ij/report_preview_edit_schneider/:rf/:cost_center_concat",
        component: ReportPreviewEditSCH,
    },

    {
        path: "/ij/rh",
        component: RhEstee,
    },
    {
        path: "/ij/rh_edit/:filial",
        component: RhEsteeEdit,
    },

    {
        path: "/ij/report_save",
        component: ReportSave,
    },
    {
        path: "/ij/report_preview",
        component: ReportPreview,
    },
    {
        path: "/ij/demo_financial",
        component: DemoFinancial,
    },
    {
        path: "/ij/preview_financial",
        component: PreviewFinancial,
    },
    {
        path: "/ij/cockpit",
        component: Cockpit,
    }, {
        path: "/ij/cockpit_preview",
        component: CockpitPreview,
    },
]
